import { render, staticRenderFns } from "./KitTotals.vue?vue&type=template&id=68adddfe"
import script from "./KitTotals.vue?vue&type=script&lang=js"
export * from "./KitTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports